export const defaultConfig = {
  enableFullscreenBtn: 'true',
  renderCanvasCSS:
    'cursor:grab;background:rgb(255, 255, 255) none repeat scroll 0% 0% / auto padding-box border-box;',
  environmentURL: '/configurator/environments/default.env',
  companyLogo: 'data:image/png;base64,',
  companyLogoToggle: 'false',
  companyLink: '',
  companyLogoCSS: 'visibility:hidden;background:none;',
  productLogo: 'data:image/png;base64,',
  productLogoToggle: 'false',
  productLink: 'https://rapidpipeline.com',
  productLogoCSS: 'visibility:hidden;background:none;',
  threeDLogo: 'data:image/png;base64,',
  threeDLogoToggle: 'false',
  threeDLogoCSS: 'visibility:hidden;background:none;',
  interactiveToolsCSS:
    'display:inline-block;right:inherit;top:inherit;left:5px;bottom:15px;background:rgba(255, 255, 255, 0.25);',
  skyBoxEnabled: 'false',
  skyBoxBlur: '0',
  skyBoxRotation: '0',
  skyBoxIntensity: '0.5',
  shadowToggle: 'true',
  shadowOpacity: '0.5',
  shadowBlur: '0',
  shadowLightIntensity: '0.3',
  cameraMinVerticalAngle: '-90',
  cameraMaxVerticalAngle: '90',
  cameraMinZoom: '1',
  cameraMaxZoom: '6',
  cameraPanning: '0.5',
  cameraBloom: '0',
  cameraContrast: '1',
  cameraExposure: '1',
  fxaaOn: 'false',
  msaaSamples: '4',
  enableSimpleMeasurement: 'false',
  enableCoordinateDisplay: 'false',
  baseUnit: 'm',
  displayUnit: 'm',
  enableARBtn: 'false',
  enableQRBtn: 'false',
  enableVRBtn: 'false',
  enableVRStand: 'false',
  vrEnvironmentName: 'vr-default',
  enableAnimationControl: 'false',
  animationSpeed: '1',
  animationIdleTime: '5',
  enableInspectorControl: 'true',
  channel: 'original',
  version: '2',
  backgroundIsGradient: 'false',
  backgroundIsColor: 'true',
  gradientBackgroundColor1: '#ffffff',
  gradientBackgroundColor2: '#aaaaaa',
  plainBackgroundColor: '#ffffff',
  environmentName: 'studio_small',
  baseUnits: 'm,cm,mm,yd,ft,in',
  displayUnits: 'm,cm,mm,yd,ft,in',
  vrEnvironments: 'vr-default,vr-hills',
  channels: 'original,normalMap,albedo,emissive,metallic',
  enableCameraAutoRotate: 'true'
};
